/**
 * Search results PLP (`/search?q=...`).
 *
 * Typography: `searchResults*TextProps` on header JSX + `SearchIdlePanel` `searchResults` theme variant.
 * Header modal idle panel keeps `SearchIdlePanel` default `baseStyle` — do not merge those styles here.
 *
 * Global styles below: page spacing + responsive layout hooks only (trending list/grid display backup).
 */

/** “N results found for …” — Section Heading 28 mobile / 40 desktop xl+ */
export const searchResultsCountTitleTextProps = {
  color: 'brandColors.greyscale90',
  fontFamily: 'body',
  fontSize: {base: '28px', xl: '40px'},
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '120%',
  letterSpacing: {base: '-0.28px', xl: '-0.4px'},
  fontVariantNumeric: 'lining-nums proportional-nums',
};

export const searchResultsEmptyLine1TextProps = {
  color: 'brandColors.greyscale90',
  fontFamily: 'body',
  fontSize: {base: '18px', xl: '40px'},
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '120%',
  letterSpacing: {base: '0', xl: '-0.4px'},
  fontVariantNumeric: 'lining-nums proportional-nums',
};

export const searchResultsEmptySubtitleTextProps = {
  color: 'brandColors.greyscale90',
  fontFamily: 'body',
  fontSize: {base: '18px', xl: '40px'},
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '120%',
  letterSpacing: {base: '0', xl: '-0.4px'},
  fontVariantNumeric: 'lining-nums proportional-nums',
};

export const searchProductListPageGlobalStyles = {
  '.sf-product-list-page:has(.sf-product-list-page-header-search)': {
    paddingTop: {base: '24px', xl: '80px'},
    paddingBottom: {base: '51px', xl: '80px'},
    paddingX: {base: 0, lg: 0},
    maxWidth: '1440px',
  },
  '.sf-product-list-page:has(.search-idle-panel--search-results) .search-idle-panel--search-results': {
    paddingBottom: {base: '20px', xl: 'unset'},
  },
  '.sf-product-list-page-header-search': {
    marginBottom: {base: '24px', xl: '48px'},
    paddingX: {base: '20px', xl: '80px'},
  },
  '[data-testid="search-results-empty-messages"]': {
    gap: {base: '16px', xl: '16px'},
    width: '100%',
  },
  '.sf-product-list-page [data-testid="search-results-idle-panel"]': {
    marginTop: {base: '24px', xl: '48px'},
    width: '100%',
  },
  '.sf-product-list-page [data-search-trending-list-mobile]': {
    display: {base: 'flex', xl: 'none'},
    flexDirection: 'column',
    gap: '4px',
    width: '100%',
  },
  '.sf-product-list-page [data-search-trending-list-grid]': {
    columnGap: '16px',
    display: {base: 'none', xl: 'grid'},
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    rowGap: '24px',
    width: '100%',
  },
  '.sf-product-list-page [data-search-trending-list-grid] > button': {
    height: 'auto !important',
    margin: '0 !important',
    minHeight: 'unset !important',
    padding: '0 !important',
    width: '100% !important',
  },
  '.sf-product-list-page [data-search-trending-list-mobile] > button': {
    height: 'auto !important',
    margin: '0 !important',
    minHeight: 'unset !important',
    width: '100% !important',
  },
  '.sf-product-list-page-search-section': {
    paddingX: {base: '20px', xl: '80px'},
  },
  '.sf-product-list-page-search-list': {
    marginX: {base: '-16px', lg: 0},
    paddingX: {base: '4px', lg: 0},
    width: {base: 'calc(100% + 2rem)', lg: '100%'},
  },
  '.sf-product-list-page-search-grid': {
    columnGap: '4px',
    rowGap: {base: '12px', lg: '32px'},
  },
  '.sf-product-list-page-search-footer': {
    alignItems: 'center',
    justifyContent: 'center',
    margin: 0,
    paddingBottom: {base: 0, xl: 0},
    paddingTop: {base: '24px', xl: '32px'},
    width: '100%',
  },
  '.sf-product-list-page-search-footer [data-testid="search-product-list-end"]': {
    color: 'grayAlpha.70',
    fontFamily: 'body',
    fontSize: 'sm',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '140%',
    margin: 0,
    padding: 0,
    textAlign: 'center',
  },
};
